package horcrux.frontend.common.views.collections.collectiondialogs

import horcrux.common.utils.toOptional
import horcrux.frontend.common.views.collections.editcollectionmenu.EditCollectionName
import horcrux.frontend.common.views.components.containers.VStack
import js.objects.jso
import mui.material.DialogContentText
import mui.system.sx
import react.FC
import react.Props
import react.ReactNode
import web.cssom.pt

external interface EditCollectionSettingsProps : Props {
    var collectionDetailsState: CollectionDetailsState
}

val EditCollectionSettings = FC<EditCollectionSettingsProps> { props ->
    val collectionNameMaybeState = props.collectionDetailsState.collectionNameMaybeState
    val collectionNameIsInvalid = props.collectionDetailsState.isCollectionNameInvalid
    VStack {
        DialogContentText {
            +"Enter a name for the document collection"
        }
        EditCollectionName {
            this.textFieldValueMaybeState = collectionNameMaybeState
            this.defaultValueMaybe =
                props.collectionDetailsState.defaultCollectionNameMaybe?.betterToString()
            this.textFieldPropsMaybe = jso {
                this.error = collectionNameIsInvalid
                this.helperText = collectionNameIsInvalid.toOptional()
                    ?.let { ReactNode("Collection name is invalid") }
                this.sx {
                    this.width = 300.pt
                }
            }
        }

        CollectionMediaTypeSelector {
            this.collectionMediaTypeState = props.collectionDetailsState.collectionMediaTypeState
            this.sx {
                this.marginTop = 15.pt
            }
        }
    }
}
